import React, {useState} from 'react';
import {
  PdfViewContainer,
  PdfViewControlPainel,
  PdfViewControlPainelLeft,
  PdfViewControlPainelRight,
  PdfViewControlPainelZoom,
  PdfViewControlPainelDownload
} from './styles';
import { P } from '../Typography/styles';
import colors from '../../assets/styles/colors';
import { Document, Page, pdfjs } from 'react-pdf';
import { BsArrowRightShort, BsArrowLeftShort, BsDownload } from 'react-icons/bs';
import { AiOutlineZoomIn, AiOutlineZoomOut } from 'react-icons/ai';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfView = ({ pdf, onDocumentLoadSuccess, pageNumber, numPages, setScale, setPageNumber, scale }) => {
  const [error, setError] = useState(null);
  const isFirstPage = pageNumber === 1;
  const isLastPage = pageNumber === numPages;

  const firstPageClass = isFirstPage ? 'disabled' : 'clickable';
  const lastPageClass = isLastPage ? 'disabled' : 'clickable';

  const goToPreviousPage = () => {
    if (!isFirstPage) setPageNumber(pageNumber - 1);
  };

  const goToNextPage = () => {
    if (!isLastPage) setPageNumber(pageNumber + 1);
  };

  const handleContextMenu = (e) => {
    e.preventDefault();
  };

  const isMinZoom = scale < 0.6;
  const isMaxZoom = scale >= 1.3;

  const zoomOutClass = isMinZoom ? 'disabled' : 'clickable';
  const zoomInClass = isMaxZoom ? 'disabled' : 'clickable';

  const zoomOut = () => {
    if (!isMinZoom) setScale(scale - 0.1);
  };

  const zoomIn = () => {
    if (!isMaxZoom) setScale(scale + 0.1);
  };
  const handleLoadError = (error) => {
    setError(error);
  };
  return (
    <PdfViewContainer onContextMenu={handleContextMenu}>
      <PdfViewControlPainel>
        <PdfViewControlPainelLeft>
          <BsArrowLeftShort 
            size={26} 
            className={firstPageClass}
            onClick={goToPreviousPage} />
          <P color={colors.textPrimary}>{pageNumber} / {numPages}</P>
          <BsArrowRightShort 
            size={26}
            className={lastPageClass}
            onClick={goToNextPage} />
        </PdfViewControlPainelLeft>
        <PdfViewControlPainelRight>
          <PdfViewControlPainelZoom>
            <AiOutlineZoomOut
              size={18}
              className={zoomOutClass}
              onClick={zoomOut}
            />
            <P color={colors.textPrimary}>{(scale * 100).toFixed()}%</P>
            <AiOutlineZoomIn
              size={18}
              className={zoomInClass}
              onClick={zoomIn}
            />
          </PdfViewControlPainelZoom>
        </PdfViewControlPainelRight>
      </PdfViewControlPainel>
      {error ? null : (
  <Document
    file={`data:application/pdf;base64,${pdf}`}
    onLoadSuccess={onDocumentLoadSuccess}
    onLoadError={handleLoadError} 
  >
    <Page pageNumber={pageNumber} scale={scale} width={800} wrap={false} customTextRenderer={false} />
  </Document>
)}
    </PdfViewContainer>
  )
}

export default PdfView;
